export default {
  dsnSend: ({ PUT }, { id, date, type }) =>
    new Promise((resolve, reject) => {
      return PUT(`production/contrats/duedsn/${id}/dsnSend`, {
        date,
        type,
      })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
  dueSend: ({ PUT }, { id, date, type }) =>
    new Promise((resolve, reject) => {
      return PUT(`production/contrats/duedsn/${id}/dueSend`, {
        date,
        type,
      })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
  dsnProcess: ({ PUT }, { id, type }) =>
    new Promise((resolve, reject) => {
      return PUT(`production/contrats/duedsn/${id}/dsnProcess`, {
        type,
      })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
  dueProcess: ({ PUT }, { id, type }) =>
    new Promise((resolve, reject) => {
      return PUT(`production/contrats/duedsn/${id}/dueProcess`, {
        type,
      })
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
}
